import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ImageFallbackResizeDirective } from '@libs/shared/utils/directives/image-fallback-resize.directive';
import { MediaImageUrlPipe } from '@libs/shared/utils/pipe/media-image-url.pipe';

@Component({
  selector: 'app-expert-workspace-logo-block',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, MediaImageUrlPipe, ImageFallbackResizeDirective],
  template: `
    <div
      class="relative"
      [ngClass]="{
        'h-6 w-6': logoSize === 'xs',
        'h-8 w-8': logoSize === 'sm',
        'h-12 w-12': logoSize === 'md',
        'h-16 w-16': logoSize === 'lg',
        'h-24 w-24': logoSize === 'xl',
      }"
      [matTooltip]="tooltip"
      matTooltipTouchGestures="on">
      <img
        appImageFallbackResize
        draggable="false"
        [ngClass]="{
          'h-6 w-6': logoSize === 'xs',
          'h-8 w-8': logoSize === 'sm',
          'h-12 w-12': logoSize === 'md',
          'h-16 w-16': logoSize === 'lg',
          'h-24 w-24': logoSize === 'xl',
          'ring-gray-200': ringType === 'default' && !showMenstruation,
          'ring-primary-500': ringType === 'primary' && !showMenstruation,
          'ring-gray-500': ringType === 'gray' && !showMenstruation,
          'ring-red-500': showMenstruation,
          'object-cover': objectType === 'object-cover',
          'object-contain': objectType === 'object-contain',
        }"
        class="flex-0 ring-bg-card app-expert-workspace-logo-image rounded-lg bg-gray-100 object-cover"
        [src]="imageFileKey | mediaImageUrl: imageSize"
        alt="logo image" />
    </div>
  `,
  styles: [
    `
      .app-expert-workspace-logo-image {
        user-drag: none;
        pointer-events: none;
        user-select: none;
        -moz-user-select: none;
        -webkit-user-drag: none;
        -webkit-user-select: none;
        -ms-user-select: none;
      }
    `,
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertWorkspaceLogoBlockComponent {
  @Input() tooltip: string;
  @Input() imageFileKey: string;
  @Input() ringType: 'default' | 'primary' | 'gray' = 'default';
  @Input() ringColor: string;
  @Input() imageSize = '300x300';
  @Input() objectType: 'object-cover' | 'object-contain' = 'object-cover';
  @Input() logoSize: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'sm';
  @Input() showMenstruation = false;
}
